import * as Sentry from '@sentry/react';
import metadata from '../metadata';
import Yup from '../validation';
export const ContactFormValidation = Yup.object({
    firstName: Yup.string().required(),
    lastName: Yup.string().required(),
    email: Yup.string().email().required(),
    phone: Yup.string().required(),
    street: Yup.string(),
    place: Yup.string(),
    message: Yup.string().required(),
    privacy: Yup.boolean().oneOf([true], 'Bitte akzeptieren Sie die Datenschutzbestimmungen'),
});
/**
 * Sends a submit request to the form framework
 * @param values
 * @returns
 */
export async function submitForm(values) {
    const res = await fetch('/hatchery/api/form/submit', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ...values,
            page_id: metadata.pageId,
            privacy: undefined, // Remove as it's not needed, field is required in the frontend
        }),
    });
    const body = await res.json();
    if (!res.ok) {
        console.log(res, body);
        const err = new Error(body?.message ?? 'Failed to submit form');
        Sentry.captureException(err);
        throw err;
    }
    return body;
}
